import React, { createContext, useState } from 'react';

export const OffersContext = createContext();

const OffersProvider = ({ children }) => {
    const [isOfferPopupOpen, setIsOfferPopupOpen] = useState(false);
    const [selectedOfferId, setSelectedOfferId] = useState('');

    return (
        <OffersContext.Provider value={{ isOfferPopupOpen, setIsOfferPopupOpen, selectedOfferId, setSelectedOfferId }}>
            {children}
        </OffersContext.Provider>
    );
};

export default OffersProvider;
